module.exports = __webpack_public_path__ + "static/media/limon-fresco.7e2b2208.png";